<template>
  <div id="footer" class="container-fluid">
    <p class="title">
      <img src="../../image/yuda.jpg" alt="qrcode" style="width:150px;display:inline-block">
      <p>公众号：裕达软件</p>
    </p>
    <p class="copy">Copyright &copy; 2018 - 2021 海南裕达股份有限公司</p>
    <p class="address_tel_fax">
      <span>地址：海南省海口市美兰区国瑞大厦C座东塔2603</span>
      <span>Tel：0898-66788518</span>
      <span>Email：sale@yudacloud.com</span>
    </p>
    <p class="email_wx">
       <span><a href="https://beian.miit.gov.cn/">琼ICP备19004264号-2</a></span>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.title {
  font-size: 20px;
  margin: 10px 0;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 12px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue